import * as React from 'react';

import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';
import { Box, Typography } from '@mui/material';

export default function CustomInput({ name, control, label, rules, multiline, type }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
          <Typography sx={{ p: 1, minWidth: 120 }}>{label}</Typography>
          <TextField
            size='small'
            error={!!error}
            multiline={multiline ? multiline.enabled : false}
            rows={multiline ? multiline.rows : undefined}
            onChange={onChange}
            value={value || ""}
            variant='outlined'
            type={type ? type : 'text'}
            sx={{ width: 140 }}
          />
          <FormHelperText sx={{ color: 'error.main', ml: 2 }}>{error?.message}</FormHelperText>
        </Box>
      )}
    />
  );
}
